import { render, staticRenderFns } from "./SponsoredRecommendation.vue?vue&type=template&id=b4ddc598&scoped=true"
import script from "./SponsoredRecommendation.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendation.vue?vue&type=style&index=0&id=b4ddc598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ddc598",
  null
  
)

export default component.exports